import React from 'react'
import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFile } from '../../../services/groupTypes'
import CetActions, { CetActionsSkeleton } from '../upload-page/upload-row/CetActions'
import UploadProgressBar from '../../../components/UploadProgressBar'

type Props = {
  asTableRow?: boolean
  file?: GedcomFile
  group?: GroupSummary
  isProcessingOrLoading: boolean
  isPrivateTree?: boolean
  isMobile: boolean
  showCombinedDesign?: boolean
}

export default function ManageTreeRowActions({
  asTableRow,
  file,
  group,
  isProcessingOrLoading,
  isPrivateTree,
  isMobile,
  showCombinedDesign,
}: Props): JSX.Element {
  if (file?.fileStatus === 'IMPORTING' && file.percentComplete != null) {
    return <UploadProgressBar isTableRow={asTableRow} percentComplete={file.percentComplete} />
  }

  const groupId = group?.id
  const treeId = group?.treeIds?.[0]
  const isResearcherTree = group?.types?.includes('RESEARCHER_TREE') ?? false
  const fileStatus = file?.fileStatus

  return (
    <CetActions
      stacked={showCombinedDesign}
      groupId={groupId}
      isManageTree
      treeId={treeId}
      fileStatus={fileStatus}
      isProcessingOrLoading={isProcessingOrLoading}
      isPrivateTree={isPrivateTree}
      isResearcherTree={isResearcherTree}
      isMobile={isMobile}
    />
  )
}

export function ManageTreeRowActionsSkeleton({ isMobile }: { isMobile?: boolean }): JSX.Element {
  return <CetActionsSkeleton isMobile={isMobile} />
}
